import { Rule } from '../../../types/Rules';

export const RULE_GROUPS: { title: string; fields: Rule['type'][] }[] = [
  {
    title: 'Trips',
    fields: ['minimum_tickets_amount', 'minimum_value', 'maximum_value', 'direct_ride'],
  },
  {
    title: 'Countries and lines',
    fields: [
      'line_whitelist',
      'line_blacklist',
      'allowed_transport_type',
      'brand_allowlist',
      'brand_disallowlist',
      'allowed_countries',
      'forbidden_countries',
      'allowed_relations',
      'forbidden_relations',
    ],
  },
  { title: 'Customer', fields: ['allowed_customer'] },
  { title: 'Travel period', fields: ['travel_period', 'weekdays_travel'] },
  { title: 'Blackout periods', fields: ['blackout_period'] },
];
